import { render, staticRenderFns } from "./chillBelt.vue?vue&type=template&id=7e9b0612"
import script from "./chillBelt.vue?vue&type=script&lang=js"
export * from "./chillBelt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports